import SiteFrequentlyAskedQuestionsComponent from "../../components/site/home/site-customer-support.component";
import SiteCustomerSupportComponent from "../../components/site/home/site-frequently-asked-questions.component";
import SiteSocialNetworkComponent from "../../components/site/home/site-social-network.component";

const FrequentlyAskedQuestionsPage = () => {
  return (
    <>
      <SiteFrequentlyAskedQuestionsComponent />
      <SiteCustomerSupportComponent />
      <SiteSocialNetworkComponent />
    </>
  );
};

export default FrequentlyAskedQuestionsPage;
